module.exports = __webpack_public_path__ + "img/cointelegraph.fb235b2.webp";